<template>
  <aside
    class="overflow-auto border-0 sidenav navbar navbar-vertical navbar-expand-xs sidenav-custom mx-md-2"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>
      <router-link 
        to="/dashboard" 
        class="m-0 navbar-brand text-center"
      >
        <div class="px-2 pt-2">
          <img src="@/assets/img/icons/logo.svg" class="img-fluid d-block mx-auto" style="max-height:48px;" alt="로고">
        </div>

      </router-link>
    </div>
    <hr class="mt-0 horizontal dark" />
    <sidenav-list :cardBg="customClass" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";

export default {
  name: "index",
  components: {
    SidenavList,
  },
  data() {
    return {
    };
  },
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.sidenav-custom {
  border-right: 1px solid rgba(0,0,0,0.1) !important; /* 색상/투명도 원하는 대로 조절 */
}
</style>
